module.exports = require("mdi-material-ui/Phone");